import { useState } from 'react';

const TONE = { green: 'badge-green', amber: 'badge-amber', red: 'badge-red', slate: 'badge-slate' };

/** Role chips with "+N" overflow (spec, RoleChips). The wrapper is a list so a screen reader hears the count. */
export default function RoleChips({ roles, max = 2, label = 'Roles' }) {
  const [all, setAll] = useState(false);
  if (!roles || roles.length === 0) return <span className="text-sm text-slate-500">No roles</span>;
  const extra = roles.length - max;
  const shown = all || extra <= 0 ? roles : roles.slice(0, max);
  return (
    <ul aria-label={label} className="m-0 flex list-none flex-wrap items-center gap-1 p-0">
      {shown.map((r) => (
        <li key={r.id}>
          <span className={TONE[r.tone] ?? TONE.slate} title={r.title}>{r.label}</span>
        </li>
      ))}
      {extra > 0 ? (
        <li>
          <button
            type="button"
            aria-expanded={all}
            aria-label={all ? 'Show fewer roles' : `Show ${extra} more ${extra === 1 ? 'role' : 'roles'}`}
            className="tap inline-flex items-center justify-center rounded-sm border border-slate-300 bg-white px-2 py-0.5 text-xs font-medium text-slate-700 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-ipc-light"
            onClick={() => setAll((v) => !v)}
          >
            {all ? 'Show fewer' : `+${extra}`}
          </button>
        </li>
      ) : null}
    </ul>
  );
}
